import { render, staticRenderFns } from "./IconSelect.vue?vue&type=template&id=70caf860&scoped=true"
import script from "./IconSelect.vue?vue&type=script&lang=js"
export * from "./IconSelect.vue?vue&type=script&lang=js"
import style0 from "./IconSelect.vue?vue&type=style&index=0&id=70caf860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70caf860",
  null
  
)

export default component.exports